<script>
import IncorporacionAbandonoSegmento from "./IncorporacionAbandonoSegmento.vue";
export default {
  props: {
    incorporaciones: {
      type: Array,
      required: true,
    },
    abandonos: {
      type: Array,
      required: true,
    },
  },
  components: {
    Segmento: IncorporacionAbandonoSegmento,
  },
  data() {
    return {
      incorporacion: null,
      abandono: null,
      cargando: false,
      error: false,
    };
  },
  created () {
    const fechaSalida = document.querySelector('[name=salida]').value.slice(0, 10);
    this.incorporacion = this.incorporaciones.find(i => i.fecha.slice(0, 10) == fechaSalida);
  },
  computed: {
    disabled() {
      return !this.incorporacion || !this.abandono;
    },
  },
  methods: {
    async procesar() {
      this.cargando = true;
      this.error = false;
      try {
        const data = await this.$parent.getOrUpdateOpciones({
          incorporacionAbandono: {
            fechaIncorporacionCircuito: this.incorporacion.fecha,
            fechaAbandonoCircuito: this.abandono.fecha,
          },
        });
        if (data.error) {
          throw new Error(data.error);
        }
        this.$emit("update", data);
      } catch (e) {
        this.error = e.message;
      }
      this.cargando = false;
    },
  },
};
</script>

<template>
  <section
    class="incorporacionAbandono"
    v-if="incorporaciones.length || abandonos.length"
  >
    <h3>Inicio y Fin</h3>
    <Segmento
      titulo="Incorporaci&oacute;n"
      :dias="incorporaciones"
      :selected="incorporacion"
      :max="abandono && abandono.fecha"
      @update="incorporacion = $event"
    />
    <Segmento
      titulo="Abandono"
      :dias="abandonos"
      :selected="abandono"
      :min="incorporacion && incorporacion.fecha"
      @update="abandono = $event"
    />

    <div v-if="error" class="alert alert-danger">{{ error }}</div>

    <button
      @click="procesar"
      type="button"
      :disabled="disabled"
      :title="disabled ? 'Eleja un día de incorporación y de abandono' : ''"
    >
      {{ cargando ? "Procesando..." : "Establecer" }}
    </button>
  </section>
</template>

<style lang="scss">
.incorporacionAbandono {
  & {
    margin: 20px 0;
  }
  .alert-danger {
    display: block !important;
    word-wrap: break-word;
  }
  button {
    background: var(--gris-oscuro);
    color: #ffffff;
    border: 0;
    outline: 0;
    font-size: 14px;
    font-weight: 700;
    padding: 6px 18px;
    font-weight: 700;
    border-radius: 10px;
    min-height: 20px;
    text-transform: capitalize;
  }
  button:disabled {
    color: var(--gris-oscuro);
    background: var(--gris-claro);
  }
}
</style>
